import styled from "styled-components";

export const StyledBubbleItem = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 0.8rem;
  padding: 0.8rem 1.6rem;
  box-sizing: border-box;
  box-shadow: 0 0 0.4rem 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 1.6rem;
  font: var(--body-small-400);
  width: fit-content;
  max-width: 90%;

  word-break: break-all;

  h1 {
    font-size: 1.6rem;
    font-weight: 600;
  }
  h2 {
    font-size: 1.4rem;
    font-weight: 600;
  }
  h3 {
    font-size: 1.2rem;
    font-weight: 600;
  }
  h4 {
    font-size: 1rem;
    font-weight: 600;
  }

  ul {
    list-style-type: disc;
    padding-inline-start: 3.2rem;
  }

  ol {
    list-style-type: decimal;
    padding-inline-start: 3.2rem;
  }

  b,
  strong {
    font-weight: 600;
  }

  blockquote {
    border-left: 0.2rem solid var(--text-gray-4);
    padding-left: 1.6rem;
    margin: 1.6rem 0;
  }

  i,
  em {
    font-style: italic;
  }

  pre {
    background-color: var(--bg-gray-1); /* 배경 색 */
    color: var(--text-gray-strong);
    border-radius: 8px; /* 모서리 둥글게 */
    padding: 16px; /* 안쪽 여백 */
    overflow-x: auto; /* 가로 스크롤 허용 */
    font-family: monospace; /* 고정폭 글꼴 */
    word-wrap: break-word; /* 긴 단어도 줄 바꿈 */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* 그림자 효과 */
    margin: 20px 0; /* 위 아래 여백 */
  }

  /* 코드 내부 텍스트 스타일 */
  code {
    color: var(--text-gray-strong); /* 글자 색 */
    font-size: 1rem; /* 글자 크기 */
    background-color: var(--bg-gray-1);
    padding: 0.4rem;
    border-radius: 0.4rem;
  }

  /* 코드 블럭에 하이라이트 추가 */
  pre code {
    background: none; /* 기본 배경 제거 */
    color: inherit; /* 상속된 색 사용 */
    padding: 0; /* 내부 여백 제거 */
    border: none; /* 테두리 제거 */
  }

  del {
    text-decoration: line-through;
  }

  &.user-bubble {
    background-color: var(--pri-blue-4);
    border-bottom-right-radius: 0;
    color: var(--text-gray-normal);
    align-self: flex-end;
  }
  &.assistant-bubble {
    background-color: var(--bg-gray-normal);
    border-bottom-left-radius: 0;
    color: var(--text-gray-strong);
    &.error {
      color: var(--sys-red-1);
    }
    .assistant-bubble-content {
      width: fit-content;
      max-width: 100%;
    }
  }
  @keyframes loading {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }

  &.loading-message {
    background: linear-gradient(
      90deg,
      var(--bg-gray-normal) 25%,
      var(--bg-gray-0) 50%,
      var(--bg-gray-normal) 75%
    );
    background-size: 200% 100%;
    animation: loading 1.5s infinite;
    border-bottom-left-radius: 0;
    color: var(--text-gray-4);
    align-self: flex-start;
    width: 100%;
  }
`;
